<template>
  <div>
    <transition name="fade">
      <div
        :key="'options_dark'"
        class="pu_dark"
        v-if="$store.getters.currentProduct"
        v-show="$store.getters.modal.product"
      ></div>
    </transition>
    <transition name="slide">
      <div
        class="pu_tovar"
        v-show="$store.getters.modal.product"
        :ref="'scrollContainer'"
        v-if="$store.getters.currentProduct"
      >
        <div class="pu_tovar_str" @click="close()"></div>
        <div
          class="pu_tovar_img"
          v-if="
            this.basketPhoto && $store.getters.currentProduct.images.length > 0
          "
        >
          <template
            v-if="
              $store.getters.currentProduct.images.length > 1 &&
              $store.getters.modal.product
            "
          >
            <slick :options="slickOptions" class="product-slider">
              <div v-for="image in $store.getters.currentProduct.images">
                <div
                  :style="{ paddingTop: placeholderPadding }"
                  class="placeholder multiple-images"
                >
                  <img
                    :src="getImageUrl(image, IMAGE_TYPE_LARGE)"
                    alt=""
                    class="placeholded-image"
                    width="100%"
                  />
                </div>
              </div>
            </slick>
          </template>
          <template v-else>
            <div
              :style="{ paddingTop: placeholderPadding }"
              class="placeholder"
            >
              <img
                :src="
                  getImageUrl(
                    $store.getters.currentProduct.images[0],
                    IMAGE_TYPE_LARGE
                  )
                "
                alt=""
                class="placeholded-image"
                width="100%"
              />
            </div>
          </template>
        </div>
        <div class="pu_tovar_content plr">
          <div class="pu_tovar_head">
            <div
              class="pu_tovar_price"
              :class="{ 'ios-font': $store.getters.checkIos }"
            >
              <template v-if="$store.getters.currentProduct.old_price">
                <span>{{
                  $options.filters.toCurrency(
                    $store.getters.currentProduct.old_price
                  )
                }}</span>
                <i v-if="hasLabel(labels.discount) && product.old_price">
                  –{{
                    Math.floor(
                      100 -
                        ($store.getters.currentProduct.price /
                          $store.getters.currentProduct.old_price) *
                          100
                    )
                  }}%
                </i>
                <br />
              </template>
              {{ $options.filters.toCurrency(countPrice) }}
            </div>
            <div class="pl_action">
              <div
                class="pl_action_inner pl_sale"
                :class="{ 'ios-font': $store.getters.checkIos }"
                v-if="hasLabel(labels.promo)"
                :style="{
                  background: getLabel(labels.promo).color,
                  color: getLabel(labels.promo).textColor,
                }"
              >
                {{ text("product_label_in_stock") }}
              </div>
              <div
                class="pl_action_inner pl_new"
                :class="{ 'ios-font': $store.getters.checkIos }"
                v-if="hasLabel(labels.new)"
                :style="{
                  background: getLabel(labels.new).color,
                  color: getLabel(labels.new).textColor,
                }"
              >
                {{ text("product_label_new") }}
              </div>
            </div>
          </div>
          <div class="pu_tovar_title">
            {{ $store.getters.currentProduct.name
            }}<span
              >{{ $store.getters.currentProduct.qty }}&nbsp;{{
                $store.getters.currentProduct.qty_unit
              }}</span
            >
          </div>

          <div v-if="$store.getters.currentProduct.modifiers.length">
            <div
              v-for="(category, index) in getCategories()"
              :key="'modifier_category_' + index"
              :id="'modifier_category_' + category.id"
            >
              <RadioBubbleModifiers
                v-if="category.is_radio_type && true"
                :category="category"
                :show-rule="hasRule(category)"
                :is-needed="isNeeded(category)"
                :in-rule="inSelectedRule(category)"
                :selected-rule-message="getSelectedRuleMessage(category)"
                :is-picked="isPicked"
                :pick="pick"
                :get-modifier-count="getModifierCount"
              />

              <RadioCardModifiers
                v-if="category.is_radio_type && true"
                :category="category"
                :show-rule="hasRule(category)"
                :is-needed="isNeeded(category)"
                :in-rule="inSelectedRule(category)"
                :selected-rule-message="getSelectedRuleMessage(category)"
                :is-picked="isPicked"
                :pick="pick"
                :get-modifier-count="getModifierCount"
              />

              <template v-if="!category.is_radio_type">
                <div class="pu_tl_head" style="margin-top: 34px">
                  <div class="pu_tl_title">
                    {{ category.name }}
                    <i v-if="category.data.is_required"
                      ><img :src="require('@/assets/img/facebook/inf_ico.svg')"
                    /></i>
                    <span v-if="hasRule(category)" class="pu_rule_msg">{{
                      getRuleMessage(category)
                    }}</span>
                  </div>
                  <div class="pu_tl_head_info">
                    <span v-if="isNeeded(category)">{{
                      text("product_options_necessary")
                    }}</span>
                    <span v-if="inSelectedRule(category)">{{
                      getSelectedRuleMessage(category)
                    }}</span>
                    <span v-if="showClearModifiersButton(category)"
                      ><img
                        @click="clearModifiers(category)"
                        :class="{
                          'pu_tl_head_info-basket_minus': !isRtl,
                          'rtl-pu_tl_head_info-basket_minus': isRtl,
                        }"
                        :src="
                          require('@/assets/img/facebook/basket_minus.svg')
                        "
                    /></span>
                  </div>
                </div>

                <div class="pu_tl_inner">
                  <label
                    v-for="(modifier, index) in getModifiers(category)"
                    @click.prevent="pick('checkbox', modifier)"
                    :id="'cat_' + category.id + '_mod_' + modifier.id"
                    :key="'cat_' + category.id + '_mod_' + index"
                    class="pu_radio pu_check"
                    :class="{
                      pu_plus: category.data.max_qty_modifier > 1,
                      pu_radio_disable: disabledElements.includes(modifier.id),
                      pu_plus_gray: blockedCategories.includes(
                        modifier.category_id
                      ),
                    }"
                  >
                    <input
                      :checked="isPicked('checkbox', modifier)"
                      type="checkbox"
                      :value="modifier.name"
                    />
                    <span class="pu_tl_name"
                      >{{ modifier.name
                      }}<i
                        class="pu_cnt"
                        v-if="
                          modifier.categoryNew.max_qty_modifier > 1 &&
                          getModifierCount(modifier.id) > 0
                        "
                        >{{ getModifierCount(modifier.id) }}</i
                      >
                    </span>
                    <template v-if="modifier.categoryNew.show_price">
                      <span v-if="!modifier.categoryNew.show_absolute_price">
                        <template v-if="modifier.display_price < 0">-</template>
                        <template v-else>+</template>
                        {{
                          modifier.display_price | toCurrency | replace("-", "")
                        }}
                      </span>
                      <span v-else>{{
                        modifier.display_price | toCurrency
                      }}</span>
                    </template>
                  </label>
                </div>
              </template>
            </div>
          </div>

          <ul class="pu_tovar_char">
            <li
              v-html="
                renderDescription($store.getters.currentProduct.description)
              "
            ></li>
          </ul>
        </div>
        <div class="pu_tovar_bottom plr">
          <div style="display: flex" v-if="$route.name === 'receipt'">
            <span class="plus-minus">
              <input type="text" name="count" :value="count" />
              <a class="cart__count-down" @click="changeCount(-1, 'count')">
                <svg
                  width="12"
                  height="2"
                  viewBox="0 0 12 2"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z"
                    fill="#1A1A1B"
                  />
                </svg>
              </a>
              <a class="cart__count-up" @click="changeCount(1, 'count')">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1C7 0.447715 6.55228 0 6 0Z"
                    fill="#1A1A1B"
                  />
                </svg>
              </a>
            </span>
          </div>
          <div
            class="pu_tovar_bottom_btn"
            :class="{ 'with-counter': $route.name === 'receipt' }"
          >
            <div
              class="btn_main pu_tovar_bottom_btn_basket"
              @click="addToBasket"
              :class="{
                pu_tovar_nav_btn_none: this.count === 0,
                btn_loading:
                  $store.getters.loading.addToBasket ||
                  $store.getters.loading.updateBasket,
              }"
            >
              {{ button }}
            </div>
          </div>
          <!--                    <div style="display: none;" class="pu_tovar_bottom_btn pu_tovar_bottom_btn_add">-->
          <!--                        <div class="btn_main pu_tovar_bottom_btn_basket pu_tovar_bottom_btn_add_inner">-->
          <!--                            <i>В корзине 1 шт.</i><span>+1 шт.</span>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div class="pu_tovar_favor"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style>
.product-slider .slick-slide {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 5px;
}
</style>

<script>
import { mapGetters } from "vuex";

const marked = require("marked");
import Slick from "vue-slick";
import "@/assets/css/slick.css";
import { ADD_TO_BASKET, UPDATE_BASKET } from "@/store/actions.type";
import { SET_MODAL } from "@/store/mutations.type";
import RadioBubbleModifiers from "@/components/ECommerce/Modifiers/RadioBubbleModifiers";
import RadioCardModifiers from "@/components/ECommerce/Modifiers/RadioCardModifiers";

const renderer = {
  code(code, infostring, escaped) {
    return "<p>" + code + "</p>";
  },
};

marked.use({ renderer });

export default {
  name: "ProductDetailed",
  components: {
    RadioCardModifiers,
    RadioBubbleModifiers,
    Slick,
  },
  data() {
    return {
      pickedModifiers: [],
      checkedModifiers: [],
      count: 1,
      loaded: false,
      alreadySelected: false,
      needToSelect: [],
      selectRules: [],
      disabledElements: [],
      blockedCategories: [],
      modifiersCount: [],

      rules: {
        default: [],
        conditions: [],
        current: [],
      },

      slickOptions: {
        autoplay: false,
        dots: true,
        infinite: false,
        speed: 300,
        edgeFriction: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: 0,
        adaptiveHeight: true,
        variableWidth: false,
        arrows: false,
        fade: false,
        rtl: false,
      },

      IMAGE_TYPE_ORIGINAL: 0,
      IMAGE_TYPE_SPLASH: 1,
      IMAGE_TYPE_SPLASH_2X: 2,
      IMAGE_TYPE_LARGE: 3,

      labels: {
        new: 0,
        discount: 1,
        promo: 2,
      },
    };
  },
  created() {
    if (this.$store.getters.guardCssDirection === "rtl") {
      this.slickOptions.rtl = true;
    }
  },
  mounted() {
    this.loadCurrentProduct();
    this.loadModifiersRules();

    this.$store.subscribe((mutation) => {
      if (mutation.type === SET_MODAL && mutation.payload.modal === "product") {
        if (mutation.payload.status === true) {
          this.alreadySelected = false;
          this.loaded = false;
          this.count = 1;
          this.checkedModifiers = [];
          this.selectRules = [];
          this.needToSelect = [];
          this.disabledElements = [];
          this.blockedCategories = [];
          this.pickedModifiers = [];
          this.modifiersCount = [];
          this.loadCurrentProduct();
          this.loadModifiersRules();
        } else {
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.scrollTo(0, 0);
          }
        }
      }
    });
  },
  methods: {
    hasLabel(type) {
      return this.$store.getters.currentProduct.labels
        ? this.$store.getters.currentProduct.labels.filter(
            (label) => label.type === type
          ).length > 0
        : false;
    },
    getLabel(type) {
      return this.product.labels.filter((label) => label.type === type)[0];
    },

    renderDescription(description) {
      let sku = "";
      if (this.$store.getters.currentProduct.sku) {
        sku =
          '<span class="sku">' +
          this.$store.getters.currentProduct.sku +
          "</span>";
      }
      return marked(this.$options.filters.nl2br(description)) + sku;
    },
    loadCurrentProduct() {
      if (this.loaded) {
        return;
      }

      let currentProduct = this.$store.getters.currentProduct;
      let selectedProducts = this.$store.getters.selectedProducts;

      if (!currentProduct) {
        return;
      }

      for (let i = 0; i < selectedProducts.length; i++) {
        const product = selectedProducts[i];
        if (product.id === currentProduct.id) {
          this.alreadySelected = true;
          if (!currentProduct.modifiers.length) {
            this.count = product.count;
          }
        }
      }

      currentProduct.modifiers.forEach((element) => {
        if (element.count != null) {
          // element.count = 0
          this.modifiersCount.push({
            modifier_id: element.id,
            count: element.count,
          });
        }
      });

      // FIND DEFAULT MODIFIERS (radio_type)
      if (currentProduct.modifiers) {
        //if product is not already in basket
        if (
          this.addNew ||
          selectedProducts.every((selected) => {
            return currentProduct.basket_item_id !== selected.basket_item_id;
          })
        ) {
          let defaultModifiers = {};
          // lets define default options
          currentProduct.modifiers.forEach((element) => {
            // we do this only for radio options
            if (element.is_radio_type === 1) {
              if (!defaultModifiers.hasOwnProperty(element.category)) {
                defaultModifiers[element.category] = [];
              }

              if (
                defaultModifiers[element.category].length === 0 &&
                element.is_default === 1
              ) {
                defaultModifiers[element.category].push(element);
              }
            }
          });
          // filled every defaultModifiers[element.category] with elements which has "is_default" param == 1

          // push found default options in data.pickedModifiers
          for (let category in defaultModifiers) {
            if (defaultModifiers[category].length !== 0) {
              this.pickedModifiers.push(defaultModifiers[category][0]);
            }
          }
        }
      }

      if (!this.addNew) {
        // FIND SELECTED MODIFIERS
        for (let i = 0; i < selectedProducts.length; i++) {
          const product = selectedProducts[i];
          if (product.basket_item_id === currentProduct.basket_item_id) {
            this.count = product.count;
            this.alreadySelected = true;
            product.modifiers.forEach((element) => {
              if (!element.is_radio_type && element.selected === 1) {
                this.checkedModifiers.push(element);
                if (element.count != null) {
                  this.setModifierCount(element.id, element.count);
                }
              }
              if (element.is_radio_type && element.selected === 1) {
                this.pickedModifiers.push(element);
              }
            });
            this.loaded = true;
          }
        }
      }
    },

    loadModifiersRules() {
      let currentProduct = this.$store.getters.currentProduct;

      if (!currentProduct) {
        return;
      }

      let rules = [];
      let conditions = [];

      let categories = this.getCategories();
      categories.forEach((category) => {
        if (!category.is_radio_type) {
          let min = null;
          let max = null;
          let maxForModifier = category.data.max_qty_modifier;

          if (category.data.total_qty_modifier) {
            min = category.data.total_qty_modifier_from;
            max = category.data.total_qty_modifier_to;
          }

          let rule = {
            category_id: category.id,
            min: min,
            max: max,
            maxForModifier: maxForModifier,
          };
          rules.push(rule);

          category.conditions.forEach((condition) => {
            let conditionRule = {
              if: {
                modifier_id: condition.modifier_id,
                category_id: condition.modifier_category_id,
              },
              category_id: category.id,
              min: condition.total_qty_form,
              max: condition.total_qty_to,
            };
            conditions.push(conditionRule);
          });
        }
      });

      this.$set(this.rules, "default", rules);
      this.$set(this.rules, "current", rules);
      this.$set(this.rules, "conditions", conditions);

      this.updateCurrentRulesAccordingConditions();
      this.updateModifiersAccordingToRules();
    },

    async addToBasket() {
      if (this.count === 0 && this.addNew) {
        this.close();
        return;
      }

      const currentProduct = this.$store.getters.currentProduct;
      let modifiersArray = [];
      let categories = this.getCategories();

      this.needToSelect = [];
      if (this.count !== 0) {
        categories.forEach((category) => {
          if (category.data.is_required) {
            let hasSelected = false;
            if (category.is_radio_type) {
              this.pickedModifiers.forEach((modifier) => {
                if (modifier.category_id === category.id) {
                  hasSelected = true;
                }
              });
              if (!hasSelected) {
                this.needToSelect.push(category);
              }
            } else {
              this.checkedModifiers.forEach((modifier) => {
                if (modifier.category_id === category.id) {
                  hasSelected = true;
                }
              });
              if (!hasSelected) {
                this.needToSelect.push(category);
              }
            }
          }
        });
        let stop = false;
        if (this.needToSelect.length !== 0) {
          this.scrollToNeedToSelect();
          stop = true;
        }
        if (this.selectRules.length !== 0) {
          this.selectRules.forEach((el) => {
            el.show = true;
          });
          if (!stop) {
            this.scrollToSelectRules();
          }
          stop = true;
        }
        if (stop) {
          return;
        }
      }

      this.pickedModifiers.forEach((element) => {
        modifiersArray.push(element.id);
      });

      this.checkedModifiers.forEach((element) => {
        if (this.getModifierCount(element.id) > 1) {
          for (let i = 0; i < this.getModifierCount(element.id); i++) {
            modifiersArray.push(element.id);
          }
        } else {
          modifiersArray.push(element.id);
        }
      });

      const modifiers = modifiersArray.join(",");

      let basketItemId = null;
      for (let i = 0; i < this.$store.getters.selectedProducts.length; i++) {
        if (this.$store.getters.selectedProducts[i].id === currentProduct.id) {
          basketItemId = this.$store.getters.selectedProducts[i].basket_item_id;
          break;
        }
      }

      let payload = {
        basketItemId: basketItemId,
        productId: currentProduct.id,
        count: this.count,
        modifiers: modifiers,
      };

      if (this.addNew) {
        await this.$store.dispatch(ADD_TO_BASKET, payload);
      } else {
        await this.$store.dispatch(UPDATE_BASKET, payload);
      }

      this.close();

      if (this.count === 0) {
        this.count = 1;
      }
    },

    close() {
      this.$store.commit(SET_MODAL, { modal: "product", status: false });
    },

    scrollToNeedToSelect() {
      let element = document.querySelector(
        "#modifier_category_" + this.needToSelect[0].id
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    scrollToSelectRules() {
      let element = document.querySelector(
        "#modifier_category_" + this.selectRules[0].category_id
      );
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    changeCount(value) {
      if (this.count + value < 0) {
        return;
      }

      this.count += value;
    },
    getCategories() {
      let categories = [];
      this.$store.getters.currentProduct.modifiers.forEach((element) => {
        if (
          categories.every((el) => {
            return el.id !== element.category_id;
          })
        ) {
          let category = {
            id: element.category_id,
            name: element.category,
          };
          category.is_radio_type = element.is_radio_type;
          category.data = element.categoryNew;
          category.conditions = element.conditions;
          categories.push(category);
        }
      });

      return categories;
    },
    getModifiers(category) {
      let result = [];
      this.$store.getters.currentProduct.modifiers.forEach((element) => {
        if (element.category_id === category.id) {
          result.push(element);
        }
      });

      return result;
    },
    isNeeded(category) {
      return this.needToSelect.some((el) => {
        return el.id === category.id;
      });
    },
    inSelectedRule(category) {
      return this.selectRules.some((el) => {
        return el.show === true && el.category_id === category.id;
      });
    },
    getSelectedRuleMessage(category) {
      let msg;
      this.selectRules.forEach((el) => {
        if (el.category_id === category.id) {
          msg = el.message;
        }
      });
      return msg;
    },
    pick(type, element) {
      if (type === "radio") {
        // if clicked modifier doesn't exist in this.pickedModifiers
        if (
          !this.pickedModifiers.some((pickedElement) => {
            return (
              pickedElement.id === element.id &&
              pickedElement.category_id === element.category_id
            );
          })
        ) {
          let i = this.pickedModifiers.length;
          while (i--) {
            if (this.pickedModifiers[i].category_id === element.category_id) {
              this.pickedModifiers.splice(i, 1);
            }
          }
          this.pickedModifiers.push(element);
        }
        this.rules.conditions.some((rule) => {
          if (rule.if.modifier_id === element.modifier_id) {
            const category = this.getCategories().find(
              (category) => category.id === rule.category_id
            );
            this.clearModifiers(category);
          }
        });
        if (
          !this.rules.conditions.some(
            (rule) => rule.if.modifier_id === element.modifier_id
          )
        ) {
          this.disabledElements = [];
        }
      }
      if (type === "checkbox") {
        if (
          !this.checkedModifiers.some((pickedElement) => {
            return (
              pickedElement.id === element.id &&
              pickedElement.category_id === element.category_id
            );
          })
        ) {
          if (
            this.blockedCategories.some((blockedCategory) => {
              return blockedCategory === element.category_id;
            })
          ) {
            return null;
          }
        }

        let currentRule;
        this.rules.current.forEach((rule) => {
          if (rule.category_id === element.category_id) {
            currentRule = rule;
          }
        });
        if (currentRule && currentRule.maxForModifier > 1) {
          if (
            this.checkedModifiers.some((pickedElement) => {
              return (
                pickedElement.id === element.id &&
                pickedElement.category_id === element.category_id
              );
            })
          ) {
            this.checkedModifiers.forEach((pickedElement, index) => {
              if (pickedElement.modifier_id === element.modifier_id) {
                let tempCount = this.getModifierCount(
                  this.checkedModifiers[index].id
                );
                if (currentRule.maxForModifier > tempCount)
                  this.setModifierCount(
                    this.checkedModifiers[index].id,
                    tempCount + 1
                  );
              }
            });
          } else {
            let tempCount = this.getModifierCount(element.id);
            if (currentRule.maxForModifier > tempCount) {
              this.setModifierCount(element.id, tempCount + 1);
              this.checkedModifiers.push(element);
            }
          }
        } else {
          if (
            this.checkedModifiers.some((pickedElement) => {
              return (
                pickedElement.id === element.id &&
                pickedElement.category_id === element.category_id
              );
            })
          ) {
            let i = this.checkedModifiers.length;
            while (i--) {
              if (this.checkedModifiers[i].id === element.id) {
                this.setModifierCount(element.id, 0);
                this.checkedModifiers.splice(i, 1);
              }
            }
          } else {
            this.setModifierCount(element.id, 1);
            this.checkedModifiers.push(element);
          }
        }
      }

      this.processConditions(type);
    },

    isPicked(type, element) {
      if (type === "radio") {
        return this.pickedModifiers.some((pickedElement) => {
          return (
            pickedElement.id === element.id &&
            pickedElement.category_id === element.category_id
          );
        });
      }
      if (type === "checkbox") {
        return this.checkedModifiers.some((pickedElement) => {
          return (
            pickedElement.id === element.id &&
            pickedElement.category_id === element.category_id
          );
        });
      }
    },

    updateCurrentRulesAccordingConditions() {
      let rules = JSON.parse(JSON.stringify(this.rules.default));

      this.rules.conditions.forEach((condition) => {
        this.pickedModifiers.forEach((pickedModifier) => {
          if (pickedModifier.modifier_id === condition.if.modifier_id) {
            rules.forEach((rule) => {
              if (condition.category_id === rule.category_id) {
                rule.min = condition.min;
                rule.max = condition.max;
              }
            });
          }
        });
      });

      this.$set(this.rules, "current", rules);
    },

    updateModifiersAccordingToRules() {
      this.rules.current.forEach((rule) => {
        let count = 0;

        let categoryModifiers = [];
        this.$store.getters.currentProduct["modifiers"].forEach(
          (currentProductModifier) => {
            if (currentProductModifier.category_id === rule.category_id) {
              categoryModifiers.push(currentProductModifier);
            }
          }
        );

        if (rule.max !== null) {
          let i = this.checkedModifiers.length;
          while (i--) {
            if (this.checkedModifiers[i].category_id === rule.category_id) {
              count = this.categoryModifiersCount.find(
                (el) => el.category_id === this.checkedModifiers[i].category_id
              ).category_count;
              if (count > rule.max) {
                count -= this.getModifierCount(this.checkedModifiers[i].id);
                if (this.getModifierCount(this.checkedModifiers[i].id)) {
                  this.setModifierCount(this.checkedModifiers[i].id, 0);
                }
                this.checkedModifiers.splice(i, 1);
              }
            }
          }

          if (rule.max === count) {
            categoryModifiers.forEach((categoryModifier) => {
              if (
                !this.disabledElements.some((el) => {
                  return el === categoryModifier.id;
                })
              ) {
                this.disabledElements.push(categoryModifier.id);
              }
              if (
                !this.blockedCategories.some((el) => {
                  return el === categoryModifier.category_id;
                })
              ) {
                this.blockedCategories.push(categoryModifier.category_id);
              }
            });
          } else {
            categoryModifiers.forEach((categoryModifier) => {
              let i = this.disabledElements.length;
              while (i--) {
                if (this.disabledElements[i] === categoryModifier.id) {
                  this.disabledElements.splice(i, 1);
                }
              }
            });

            categoryModifiers.forEach((categoryModifier) => {
              let i = this.blockedCategories.length;
              while (i--) {
                if (
                  this.blockedCategories[i] === categoryModifier.category_id
                ) {
                  this.blockedCategories.splice(i, 1);
                }
              }
            });
          }
        }

        if (rule.min !== null) {
          if (count < rule.min) {
            let hasSelectedRule = false;
            this.selectRules.forEach((selectRule) => {
              if (rule.category_id === selectRule.category_id) {
                hasSelectedRule = true;
                selectRule.message = this.text("product_options_choose_more", {
                  amount: rule.min - count,
                });
              }
            });
            if (!hasSelectedRule) {
              this.selectRules.push({
                show: false,
                category_id: rule.category_id,
                message: this.text("product_options_choose_more", {
                  amount: rule.min - count,
                }),
              });
            }
          } else {
            let i = this.selectRules.length;
            while (i--) {
              if (this.selectRules[i].category_id === rule.category_id) {
                this.selectRules.splice(i, 1);
              }
            }
          }
        }
      });
    },

    processConditions(type) {
      if (type === "radio") {
        this.updateCurrentRulesAccordingConditions();
        this.updateModifiersAccordingToRules();
      }

      if (type === "checkbox") {
        this.updateModifiersAccordingToRules();
      }
    },

    clearModifiers(category) {
      let i = this.checkedModifiers.length;
      while (i--) {
        if (this.checkedModifiers[i].category_id === category.id) {
          if (this.getModifierCount(this.checkedModifiers[i].id)) {
            this.setModifierCount(this.checkedModifiers[i].id, 0);
          }
          this.checkedModifiers.splice(i, 1);
        }
      }

      this.updateModifiersAccordingToRules();
    },

    showClearModifiersButton(category) {
      if (category.data.max_qty_modifier <= 1) {
        return false;
      }

      let count = 0;
      this.getModifiers(category).forEach((modifier) => {
        count += this.getModifierCount(modifier.id);
      });

      return count > 0;
    },

    setModifierCount(modifier_id, count) {
      this.modifiersCount.forEach((modifier) => {
        if (modifier.modifier_id === modifier_id) {
          modifier.count = Number(count);
        }
      });
    },
    getModifierCount(modifier_id) {
      let count = null;
      this.modifiersCount.forEach((modifier) => {
        if (modifier.modifier_id === modifier_id) {
          count = modifier.count;
        }
      });
      return count;
    },

    hasRule(category) {
      return this.rules.current.some((el) => {
        return el.category_id === category.id && (el.min || el.max);
      });
    },

    getRuleMessage(category) {
      let rule;

      this.rules.current.forEach((el) => {
        if (el.category_id === category.id) {
          rule = el;
        }
      });

      let message = this.text("product_options_choose");
      if (rule.min && rule.max) {
        message +=
          " " +
          this.text("product_options_from_to", {
            amount_from: rule.min,
            amount_to: rule.max,
          }) +
          " ";
      } else {
        if (rule.min) {
          message += " " + this.text("product_options_from") + " " + rule.min;
        }
        if (rule.max) {
          message += " " + this.text("product_options_to") + " " + rule.max;
        }
      }

      return message;
    },

    getImageUrl(image, type) {
      let params = "";

      if (type === this.IMAGE_TYPE_ORIGINAL) {
        return image.original + params;
      }
      if (type === this.IMAGE_TYPE_SPLASH) {
        return image.splash + params;
      }
      if (type === this.IMAGE_TYPE_SPLASH_2X) {
        return image.splash_2x + params;
      }
      if (type === this.IMAGE_TYPE_LARGE) {
        return image.large + params;
      }
    },
  },
  computed: {
    isRtl() {
      return this.$store.getters.guardCssDirection === "rtl";
    },
    placeholderPadding() {
      let padding = "66.67%";

      if (
        this.imagesStyle === this.$store.getters.IMAGES_SQUARE_LEFT ||
        this.imagesStyle === this.$store.getters.IMAGES_SQUARE_RIGHT ||
        this.imagesStyle === this.$store.getters.IMAGES_VERTICAL
      ) {
        padding = "100%";
      }

      return padding;
    },

    countPrice() {
      const { fullPrice, price } = this.$store.getters.currentProduct;
      let currentPrice = fullPrice < price ? fullPrice : price;

      this.pickedModifiers.forEach((picked) => {
        currentPrice += picked.price;
      });

      this.checkedModifiers.forEach((selected) => {
        if (this.getModifierCount(selected.id) > 1) {
          currentPrice += selected.price * this.getModifierCount(selected.id);
        } else {
          currentPrice += selected.price;
        }
      });

      if (price < 0) {
        currentPrice = 0;
      }

      return currentPrice * this.count;
    },

    addNew() {
      let basketItemId = null;
      for (let i = 0; i < this.$store.getters.selectedProducts.length; i++) {
        if (
          this.$store.getters.selectedProducts[i].id ===
          this.$store.getters.currentProduct.id
        ) {
          basketItemId = this.$store.getters.selectedProducts[i].basket_item_id;
          break;
        }
      }
      return (
        (this.$router.currentRoute.name !== "receipt" &&
          this.$store.getters.currentProduct.modifiers.length) ||
        !basketItemId
      );
    },

    button() {
      if (!this.addNew && this.alreadySelected) {
        if (this.count === 0) {
          return this.text("product_remove");
        } else {
          return this.text("product_save");
        }
      } else {
        if (this.count === 0) {
          return this.text("clear_basket_cancel");
        } else {
          return this.text("product_add");
        }
      }
    },

    selectedCount() {
      let currentProduct = this.$store.getters.currentProduct;

      let basketItemId = null;
      for (let i = 0; i < this.$store.getters.selectedProducts.length; i++) {
        if (this.$store.getters.selectedProducts[i].id === currentProduct.id) {
          basketItemId = this.$store.getters.selectedProducts[i].basket_item_id;
          break;
        }
      }
    },
    ...mapGetters([
      "basketPhoto",
      "imagesStyle",
      "IMAGES_SQUARE_MINIATURE",
      "IMAGES_SQUARE_LEFT",
      "IMAGES_SQUARE_RIGHT",
      "IMAGES_WIDE",
      "modal",
    ]),
  },
};
</script>

<style scoped>
.btn_main {
  transition: all 0.1s;
}

.pu_tovar_bottom_btn.with-counter {
  width: calc(100% - 165px);
}

.pu_tovar_bottom_btn.with-counter .btn_main.pu_tovar_bottom_btn_basket {
  width: auto;
}

.pu_tovar_nav_btn_none {
  color: #eb4253;
  background: #fdf0f1;
  -webkit-box-shadow: 0px 0px 0px #fff;
  box-shadow: 0px 0px 0px #fff;
}

.pu_rule_msg {
  display: block;
  font-size: 12px;
}

.pl_action {
  display: flex;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
}

.pl_action_inner {
  height: 16px;
  line-height: 16px;
  width: 40px;
  text-align: center;
  border-radius: 2px;
  font-size: 9px;
  font-weight: bold;
}

.pl_action_inner + .pl_action_inner {
  margin-left: 5px;
}

.pl_sale {
  background: #fefcdb;
  color: #3d3d3d;
}

.pl_new {
  color: #fff;
  background: #00a455;
}

.pl_sale_num {
  font-size: 13px;
  color: #fff;
  font-weight: bold;
  position: absolute;
  z-index: 20;
  left: 10px;
  bottom: 10px;
  height: 21px;
  line-height: 21px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  background: #eb4253;
  width: 48px;
  text-align: center;
}

.pu_tovar {
  position: fixed;
  z-index: 10001;
  background: #fff;
  padding: 0 0 84px;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.pu_tovar_img img {
  display: block;
  width: 100%;
}

.pu_tovar_str {
  position: fixed;
  width: 40px;
  height: 40px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  background: #fff url("../../../assets/img/ecommerce/pu_str.svg") no-repeat
    center center;
  z-index: 999999999;
  right: 16px;
  top: 12px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.pu_tovar_head {
  display: flex;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.pu_tovar_head .pl_action_inner {
  height: 26px;
  line-height: 26px;
  width: 74px;
  font-size: 11px;
  font-weight: bold;
}

.pu_tovar_price {
  font-size: 25px;
  line-height: 100%;
  color: #000000;
  font-weight: bold;
}

.pu_tovar_price span {
  padding-bottom: 4px;
  display: inline-block;
  font-size: 13px;
  color: #1a1a1b;
  opacity: 0.5;
  line-height: 100%;
}

.pu_tovar_price i {
  padding-bottom: 4px;
  display: inline-block;
  font-style: normal;
  color: #eb4253;
  font-size: 13px;
  margin-left: 13px;
  line-height: 100%;
}

.pu_tovar_content {
  margin-top: 23px;
  padding-bottom: 40px;
}

.pu_tovar_title {
  font-size: 20px;
  font-weight: 500;
  color: #000000;
  line-height: 120%;
  margin-top: 34px;
}

.pu_tovar_title span {
  display: block;
  font-size: 14px;
  line-height: 120%;
  font-weight: normal;
  color: #999;
  margin-top: 3px;
}

.pu_tovar_char {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
  margin-top: 34px;
}

.pu_tovar_char > li {
  display: block;
}

.pu_tovar_char > li + li {
  margin-top: 34px;
}

.pu_tc_title {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  line-height: 120%;
}

.pu_tc_text {
  margin-top: 19px;
}

.pu_tc_text p {
  display: block;
  margin: 0;
  font-size: 14px;
  line-height: 18px;
  color: #999;
}

.pu_tc_text p + p {
  margin-top: 12px;
}

.pu_tc_info {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pu_tc_info > li {
  display: block;
  font-size: 14px;
  color: rgba(26, 26, 27, 0.6);
}

.pu_tc_info > li span {
  color: #1a1a1b;
  display: inline-block;
  margin-left: 7px;
}

.pu_tc_info > li + li {
  margin-top: 8px;
}

.pu_tc_info_btn_all {
  font-size: 14px;
  color: #0084ff;
  margin-top: 14px;
}

.pu_tc_delivery {
  display: block;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pu_tc_delivery > li {
  display: flex;
  font-size: 14px;
  line-height: 18px;
  color: #999;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.pu_tc_delivery > li + li {
  margin-top: 5px;
}

.pu_tc_delivery + .pu_tc_text {
  margin-top: 14px;
}

.pu_tovar_bottom {
  position: fixed;
  width: 100%;
  display: flex;
  z-index: 9999999999;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  left: 0;
  bottom: 0;
  background: #fff;
  height: 84px;
  box-shadow: 0px -1px 15px rgba(0, 0, 0, 0.05);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.pu_tovar_bottom_btn_basket {
  width: 245px;
  text-align: center;
  padding-left: 0;
  padding-right: 0;
}

.pu_tovar_favor {
  width: 30px;
  height: 30px;
  min-width: 30px;
  margin-right: 10px;
  background: url("../../../assets/img/ecommerce/tovar_metka.svg") no-repeat
    center center;
}

.pu_tovar_favor_act {
  background: url("../../../assets/img/ecommerce/tovar_metka_act.svg") no-repeat
    center center;
}

.pu_tovar_bottom_btn_add_inner {
  text-align: center;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.pu_tovar_bottom_btn_add_inner span {
  display: block;
  width: 73px;
  font-size: 15px;
  font-weight: 500;
  height: 52px;
  line-height: 52px;
  background: #006acd;
  -webkit-border-top-right-radius: 16px;
  border-top-right-radius: 16px;
  -webkit-border-bottom-right-radius: 16px;
  border-bottom-right-radius: 16px;
}

.pu_tovar_bottom_btn_add_inner i {
  display: block;
  width: 173px;
  text-align: center;
  font-style: normal;
}

/*@media*/
@media screen and (max-width: 380px) {
  .popular_list > li {
    width: 310px;
    min-width: 310px;
  }

  .popular_list > li + li {
    margin-left: 20px;
  }
}

@media screen and (max-width: 360px) {
  .plt_img {
    width: 120px;
    min-width: 120px;
  }

  .hb_inner {
    width: 270px;
  }

  .hb_title {
    padding-left: 19px;
    padding-top: 16px;
  }

  .hb_title {
    font-size: 18px;
    line-height: 22px;
  }

  .hb_title span {
    margin-top: 6px;
  }

  .popular_list > li {
    width: 250px;
    min-width: 250px;
  }

  .popular_list > li + li {
    margin-left: 10px;
  }

  .pl_price {
    right: 10px;
    bottom: 10px;
    height: 34px;
    line-height: 36px;
  }
}

@media screen and (max-width: 320px) {
  .pu_tovar_favor {
    margin-right: -5px;
  }

  .pu_tovar_size_list > li {
    font-size: 13px;
  }

  .pu_tovar_price {
    font-size: 23px;
  }
}

div.placeholder {
  width: 100%;
  height: 0;
  background: #f7f7f7;
  position: relative;
}

img.placeholded-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

/*.multiple-images::after {*/
/*    content: '';*/
/*    display: block;*/
/*    position: absolute;*/
/*    left: 0;*/
/*    top: 0;*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    background: linear-gradient(rgba(0, 0, 0, 0.5) 0%, transparent 10%);*/
/*}*/
</style>
